'use client';

import { memo } from 'react';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { BURGER_MENU_ID } from '@headless-workspace/config';
import { useModalActions } from '@headless-workspace/core-ui';
import { GlowClickable, GlowIcon, Icons } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';

export const BurgerMenuHeader: ComponentMemo = memo(() => {
    const t = useTranslations('Common.action.label'); // Assuming you have a translation hook
    const { close: closeMenu } = useModalActions();

    const onCrossClick = () => {
        closeMenu(BURGER_MENU_ID);
    };

    return (
        <div className={clsx('flex flex-row justify-between items-center p-1')}>
            <GlowIcon Icon={Icons.LogoSephora} className={'h-sephoraLogoSmall text-text-primary'} type={'fullSize'} />
            <GlowClickable
                onClick={onCrossClick}
                className={'text-text-primary'}
                ariaLabel={t('close')}
                content={{
                    icon: <GlowIcon Icon={Icons.Cross} type={'large'} />,
                }}
            />
        </div>
    );
});

BurgerMenuHeader.displayName = 'BurgerMenuHeader';
